/* ** *** *** ***
Covetrus PCI/Security Notice:
This file has been identified as potentially impacting user and/or data security.
All modifications to these files must be reviewed and merged by a designated Security Champion for this application.
Additional information, including specifics for Pull Requests, can be found here:
https://dvmwiki.atlassian.net/wiki/spaces/MCT/pages/507511182/Code+Reviews
*** *** *** ** */

import React from 'react';
import { reduxForm } from 'redux-form';
import PropTypes from 'prop-types';

import validate from './Validations/creditCardInfoFormValidation';
import warn from './Validations/creditCardInfoFormWarning';
import styles from './CreditCardInfoForm.css';

const baseUrl = `${AUTHNET_BASE_URL}customer/`;

const addPayment = isHidden => {
  if (isHidden !== undefined) {
    setTimeout(
      () => {
        const tokenEl = document.getElementById('send_token');
        const iFrame = document.getElementById('add_payment');
        if (iFrame != null) {
          if (tokenEl != null && isHidden) {
            tokenEl.setAttribute('action', `${baseUrl}addPayment`);
            tokenEl.setAttribute('target', 'add_payment');
            tokenEl.submit();
          } else if (!isHidden) {
            iFrame.style.minHeight = '800px';
          }
          iFrame.hidden = isHidden;
        }
      },
      0,
      isHidden
    );
  }
};

const CreditCardInfoForm = ({ token, profileId, hidden }) => (
  <div className={styles.iFrameHolder}>
    <form id="send_token" action="" method="post" target="add_payment">
      <input type="hidden" name="token" value={token} />
      <input type="hidden" name="customerProfileId" value={profileId} />
    </form>
    {addPayment(hidden)}
  </div>
);

CreditCardInfoForm.propTypes = {
  token: PropTypes.string,
  profileId: PropTypes.string,
  hidden: PropTypes.bool,
};

export const formName = 'CreditCardInfoForm';

export default reduxForm({
  form: formName,
  validate,
  warn,
})(CreditCardInfoForm);



// WEBPACK FOOTER //
// ./src/components/Forms/CreditCardInfoForm.jsx